(function () {
  var STORAGE_KEYS = {
    seen: 'delivery_postal_modal_seen',
    postal: 'delivery_postal_code'
  };

  var HOME_BANNER_ANCHOR_SELECTORS = [
    '#shopify-section-slideshow',
    '[id*="__slideshow"]',
    '#MainContent .shopify-section:first-child',
    'main .shopify-section:first-child'
  ];

  var BAR_ANCHOR_SELECTORS = [
    '#site-control',
    '#shopify-section-sections--announcement-bar',
    '#shopify-section-announcement-bar',
    '.announcement-bar',
    '#shopify-section-header',
    '.section-header',
    'header.header'
  ];
  

  var modal = document.getElementById('delivery-postal-modal');
  var input = document.getElementById('delivery-postal-modal-input');
  var isHomePage = document.body.classList.contains('template-index');

  if (!modal) return;

  function safeGet(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSet(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {}
  }

  function normalizePostal(value) {
    return (value || '').trim().replace(/\s+/g, ' ').toUpperCase();
  }

  function hasSeenModal() {
    return safeGet(STORAGE_KEYS.seen) === 'true';
  }

  function setSeenModal() {
    safeSet(STORAGE_KEYS.seen, 'true');
  }

  function getSavedPostal() {
    return safeGet(STORAGE_KEYS.postal) || '';
  }

  function setSavedPostal(value) {
    var normalized = normalizePostal(value);
    if (!normalized) return;
    safeSet(STORAGE_KEYS.postal, normalized);
  }

  function lockBodyScroll() {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function unlockBodyScroll() {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  function openModal() {
    modal.classList.add('is-visible');
    modal.setAttribute('aria-hidden', 'false');
    lockBodyScroll();

    setTimeout(function () {
      if (input) input.focus();
    }, 30);
  }

  function closeModal() {
    modal.classList.remove('is-visible');
    modal.setAttribute('aria-hidden', 'true');
    unlockBodyScroll();
  }

  function injectBarStyles() {
    if (document.getElementById('delivery-recheck-bar-styles')) return;

    var style = document.createElement('style');
    style.id = 'delivery-recheck-bar-styles';
    style.textContent = `
      .delivery-recheck-bar {
        display: none;
        width: 100%;
        background: #0e211c;
        color: #ffffff;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
      }
      .delivery-recheck-bar.is-visible {
        display: block;
      }
      .delivery-recheck-bar__inner {
        display: flex;
        align-items: center;
        justify-content: center;
        width: min(100%, 1400px);
        margin: 0 auto;
        padding: 22px 24px;
      }
      .delivery-recheck-bar__content {
        border: 0;
        background: transparent;
        padding: 0;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 14px;
        text-align: center;
        color: #ffffff;
        font: inherit;
        transition: opacity 0.15s ease;
      }
      .delivery-recheck-bar__content:hover,
      .delivery-recheck-bar__content:focus-visible {
        opacity: 0.85;
        outline: none;
      }
      .delivery-recheck-bar__icon {
        display: inline-flex;
        flex-shrink: 0;
        width: 26px;
        height: 26px;
      }
      .delivery-recheck-bar__icon svg {
        width: 100%;
        height: 100%;
        display: block;
      }
      .delivery-recheck-bar__label {
        font-size: 20px;
        font-weight: 500;
        line-height: 1.35;
        letter-spacing: 0.02em;
      }
      .delivery-recheck-bar__postal {
        font-weight: 700;
        text-decoration: underline;
        text-underline-offset: 4px;
      }
      .delivery-recheck-bar__action {
        display: inline-block;
        margin-left: 14px;
        padding: 7px 16px;
        border: 1px solid rgba(255, 255, 255, 0.5);
        border-radius: 999px;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        line-height: 1;
      }
      @media screen and (max-width: 767px) {
        .delivery-recheck-bar__inner {
          padding: 16px 16px;
        }
        .delivery-recheck-bar__content {
          gap: 10px;
          flex-wrap: wrap;
        }
        .delivery-recheck-bar__label {
          font-size: 16px;
        }
        .delivery-recheck-bar__action {
          margin-left: 8px;
          padding: 5px 12px;
          font-size: 12px;
        }
        .delivery-recheck-bar__icon {
          width: 20px;
          height: 20px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function findBarAnchor() {
    if (isHomePage) {
      for (var j = 0; j < HOME_BANNER_ANCHOR_SELECTORS.length; j++) {
        var homeEl = document.querySelector(HOME_BANNER_ANCHOR_SELECTORS[j]);
        if (homeEl) return homeEl;
      }
    }

    for (var i = 0; i < BAR_ANCHOR_SELECTORS.length; i++) {
      var el = document.querySelector(BAR_ANCHOR_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function createBar() {
    var existing = document.getElementById('delivery-recheck-bar');
    if (existing) return existing;

    injectBarStyles();

    var bar = document.createElement('div');
    bar.id = 'delivery-recheck-bar';
    bar.className = 'delivery-recheck-bar';
    bar.innerHTML = `
      <div class="delivery-recheck-bar__inner">
        <div
          class="delivery-recheck-bar__content"
          role="button"
          tabindex="0"
          aria-label="Recheck delivery availability"
        >
          <span class="delivery-recheck-bar__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22s7-6.5 7-12a7 7 0 1 0-14 0c0 5.5 7 12 7 12Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
              <circle cx="12" cy="10" r="2.5" stroke="currentColor" stroke-width="1.8"/>
            </svg>
          </span>
          <span class="delivery-recheck-bar__label">Check delivery availability</span>
          <span class="delivery-recheck-bar__action">Change</span>
        </div>
      </div>
    `;

    var anchor = findBarAnchor();
    if (anchor && anchor.parentNode) {
      anchor.insertAdjacentElement('afterend', bar);
    } else {
      document.body.insertAdjacentElement('afterbegin', bar);
    }

    var content = bar.querySelector('.delivery-recheck-bar__content');
    if (content) {
      content.addEventListener('click', function () {
        openModal();
      });
      content.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openModal();
        }
      });
    }

    return bar;
  }

  function escapeHTML(value) {
    return String(value).replace(/[&<>"']/g, function (ch) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[ch];
    });
  }

  function updateBarText() {
    var bar = createBar();
    var label = bar.querySelector('.delivery-recheck-bar__label');
    var action = bar.querySelector('.delivery-recheck-bar__action');
    if (!label) return;

    var savedPostal = getSavedPostal();
    if (savedPostal) {
      label.innerHTML =
        'Delivering to <span class="delivery-recheck-bar__postal">' +
        escapeHTML(savedPostal) +
        '</span>';
      if (action) action.style.display = '';
    } else {
      label.textContent = 'Enter your postal code to check same-day delivery eligibility.';
      if (action) action.style.display = 'none';
    }
  }

  function showBar() {
    if (!isHomePage) return;
    var bar = createBar();
    updateBarText();
    bar.classList.add('is-visible');
  }

  function hideBar() {
    var bar = document.getElementById('delivery-recheck-bar');
    if (bar) {
      bar.classList.remove('is-visible');
    }
  }

  function initBarState() {
    if (!isHomePage) return;
    createBar();
    if (hasSeenModal()) {
      showBar();
    } else {
      hideBar();
    }
  }

  var persistence = {
    hasSeenModal: hasSeenModal,
    markSeen: function () {
      setSeenModal();
      showBar();
    },
    setSavedPostal: setSavedPostal,
    getSavedPostal: getSavedPostal,
    openModal: openModal,
    showBar: showBar,
    hideBar: hideBar,
    init: initBarState
  };

  window.deliveryPostalModalPersistence = persistence;

  if (document.readyState !== 'loading') {
    initBarState();
  } else {
    document.addEventListener('DOMContentLoaded', initBarState);
  }
})();

(function () {
  const MODAL_SHOWN_KEY = 'delivery_postal_modal_shown';
  const MODAL_TIMESTAMP_KEY = 'delivery_postal_modal_timestamp';
  const SESSION_TIMEOUT = 60 * 60 * 1000; // 1 hour in milliseconds

  // Function to check if the modal should be shown
  function shouldShowModal() {
    const lastShown = localStorage.getItem(MODAL_TIMESTAMP_KEY);
    const currentTime = Date.now();

    // If the modal has never been shown or 1 hour has passed
    return !lastShown || (currentTime - lastShown >= SESSION_TIMEOUT);
  }

  // Function to set the timestamp when the modal is shown
  function setModalTimestamp() {
    localStorage.setItem(MODAL_TIMESTAMP_KEY, Date.now());
  }

  // Function to show the modal
  function showModal() {
    const modalPopover = document.querySelector(".delivery-postal-modal");
    if (modalPopover) {
      modalPopover.classList.add('is-visible');
      modalPopover.setAttribute("aria-hidden", "false");
      setModalTimestamp(); // Set the timestamp when the modal is shown
    }
  }

  // Function to close the modal
  function closeModal() {
    const modalPopover = document.querySelector(".delivery-postal-modal");
    if (modalPopover) {
      modalPopover.classList.remove('is-visible');
      modalPopover.setAttribute("aria-hidden", "true");
    }
  }

  var isHomePage = document.body.classList.contains('template-index');

  // Check if the modal should be shown and show it after a delay (homepage only)
  window.addEventListener('load', function() {
    if (!isHomePage) return;

    setTimeout(function() {
      if (shouldShowModal()) {
        showModal();
      }
    }, 3000); // 3-second delay before showing the modal
  }); 

  // Close the modal when the user interacts with it or after certain actions
  document.getElementById('delivery-postal-modal-skip')?.addEventListener('click', function () {
    closeModal();
  });

})();